export const HOME = '/home'
export const SUPPLIER = '/supplier'
export const USERS = '/users'
export const TRIPS = '/trips'
export const BOOKINGS = '/booking'
export const PAYMENTS = '/payments'
export const BOOKABLE_ACTIVITIES = '/bookables'
export const SUPPLIER_CREATE = '/create-supplier'
export const BOOKABLE_CREATE = '/bookables/create-bookable'
export const BOOKABLE_EDIT = '/bookables/edit/:id'
export const ACTIVITY_CREATE = '/create-activity'
export const SPREADSHEET_IMPORT = '/import-trip'
export const OUTREACH = '/outreach'
export const GUEST_PROFILE = '/outreach/guest/:uuid'
export const ANALYTICS = '/analytics'
export const TRIP_INSPIRATION = '/trip-inspiration'
export const NUDGES = '/nudges'
export const LOGIN = '/login'
export const FORGOT_PASSWORD = '/forgot-password'
export const RESET_PASSWORD = '/reset-password'
